<template>
  <div
    v-if="hasNameSlot || hasButtonSlot || hasNotifSlot"
    style="display: contents"
  >
    <div
      v-if="hasNameSlot || hasButtonSlot"
      class="menu-bar padded-bar padded-container"
    >
      <div v-if="hasNameSlot" class="item-name">
        <slot name="item-name" />
      </div>
      <div
        v-if="hasButtonSlot"
        class="button-bar-container"
        :class="{ 'full-width': !hasNameSlot }"
      >
        <div class="button-bar">
          <slot name="buttons" />
        </div>
      </div>
    </div>
    <div v-if="hasNotifSlot" class="notification-bar padded-container">
      <slot name="notifications" />
    </div>
  </div>
</template>

<script>
import { Comment, Fragment } from 'vue'

function hasVisibleContent(vnodes) {
  return vnodes.some((vn) => {
    if (!vn || vn.type === Comment) return false
    if (vn.type === Fragment) {
      return hasVisibleContent(Array.isArray(vn.children) ? vn.children : [])
    }
    return true
  })
}

export default {
  name: 'PageTopBar',
  computed: {
    hasNameSlot() {
      return !!this.$slots['item-name']
    },
    hasButtonSlot() {
      return !!this.$slots['buttons']
    },
    hasNotifSlot() {
      const slot = this.$slots['notifications']
      return !!slot && hasVisibleContent(slot())
    },
  },
}
</script>

<style scoped>
.padded-bar {
  padding-top: var(--space-1);
  padding-bottom: var(--space-2);
}

.menu-bar {
  display: flex;
  flex-wrap: wrap-reverse;
  column-gap: var(--space-2);
  width: 100%;
  background-color: var(--color-background-default);
}

.notification-bar {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  width: 100%;
  padding-top: var(--space-2);
  padding-bottom: var(--space-2);
  background-color: var(--color-background-default);
}

.item-name {
  display: flex;
  align-items: center;
  flex-grow: 1;
  min-width: 150px;
  max-width: 100%;
  flex-shrink: 1;
}
.item-name > :is(div, span) {
  font-size: 1.1em;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}

.button-bar-container {
  display: flex;
  justify-content: flex-end;
  flex-shrink: 0;
  margin-left: auto;
  max-width: 100%;
}

.button-bar-container.full-width {
  margin-left: 0;
  flex-grow: 1;
  justify-content: flex-start;
}

.button-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: var(--space-1);
}

.button-bar-container.full-width .button-bar {
  margin-left: 0;
  align-items: flex-start;
  flex-grow: 1;
}

.item-name > * {
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
